

import { Observable } from 'rxjs';



export interface WardBasedDefaultService {
    id?: number;
    tenantId: any;
    branchId: any;
    serviceId: any;
    wardId: any;
    createdDate?: Date;
    createdBy: number;
    createdIP?: string;
    ward?: any;
    service?: any;
}

export abstract class WardBasedDefaultServiceData {
    abstract list(url: string): Observable<any>;
    abstract create(url: string, data: WardBasedDefaultService): Observable<WardBasedDefaultService[]>;
    abstract delete(url: string): Observable<any>;

}
